/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 2
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/revelata/deepkpi_test/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: ''
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '2',
    branch: 'main',
    source: 'web',
    versionId: '0ebebd6e-839f-4fd8-a87a-3cbff6544c43'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  initial_dclid?: any;
  initial_fbclid?: any;
  initial_gbraid?: any;
  initial_gclid?: any;
  initial_ko_click_id?: any;
  initial_li_fat_id?: any;
  initial_msclkid?: any;
  initial_referrer?: any;
  initial_referring_domain?: any;
  initial_rtd_cid?: any;
  initial_ttclid?: any;
  initial_twclid?: any;
  initial_utm_campaign?: any;
  initial_utm_content?: any;
  initial_utm_id?: any;
  initial_utm_medium?: any;
  initial_utm_source?: any;
  initial_utm_term?: any;
  initial_wbraid?: any;
  referrer?: any;
  referring_domain?: any;
}

export interface CommonCreateAccountCompletedProperties {
  Company: string;
  "Invitation Code": string;
}

export interface CommonWebappSignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface CreateAccountButtonClickProperties {
  Company: string;
  "Invitation Code": string;
}

export interface DaWebappQueryComplexProperties {
  /**
   * User's query input into AI chat
   */
  "Chat Query": string;
}

export interface DaWebappQuerySimpleProperties {
  /**
   * User's query input into AI chat
   */
  "Chat Query": string;
}

export interface DaWebappSignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface DataAuditProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index"?: number;
  "Chart Title"?: string;
  "Contains Latest Filing"?: boolean;
  Description?: string;
  "Display Datetime"?: string;
  "Display Value"?: string;
  "Doc Type"?: string;
  "Filing Date": string;
  "Form Type"?: string;
  "Has Duplicate Time Series"?: string;
  Hint?: string;
  Modifier?: string;
  /**
   * The caller requesting provenance data.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | app, docviewer |
   */
  "Provenance Caller": "app" | "docviewer";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Provenance Details": string[];
  /**
   * Data API version
   */
  "Provenance Version"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Reporting Period": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx"?: number;
  Sentence: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length"?: number;
  Unit?: string;
}

export interface DataExportProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface DiDownloadedAssetProperties {
  /**
   * Download URL
   */
  "Download URL": string;
}

export interface DkDataAuditProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index"?: number;
  "Chart Title"?: string;
  "Contains Latest Filing"?: boolean;
  Description?: string;
  "Display Datetime"?: string;
  "Display Value"?: string;
  "Doc Type"?: string;
  "Filing Date": string;
  "Form Type"?: string;
  "Has Duplicate Time Series"?: string;
  Hint?: string;
  Modifier?: string;
  /**
   * The caller requesting provenance data.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | app, docviewer |
   */
  "Provenance Caller": "app" | "docviewer";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Provenance Details": string[];
  /**
   * Data API version
   */
  "Provenance Version"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Reporting Period": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx"?: number;
  Sentence: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length"?: number;
  Unit?: string;
}

export interface DkWebappCategorySelectionProperties {
  Expanded: boolean;
  "Section Name": string;
}

export interface DkWebappChartExpansionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface DkWebappChartSelectionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface DkWebappExcelExportProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface DkWebappExcelExportMergeProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface DkWebappFormTypeChangeProperties {
  /**
   * A set of form types: 10-K, 10-Q, 8-K
   *
   * | Rule | Value |
   * |---|---|
   * | Max Items | 3 |
   * | Unique Items | true |
   * | Item Type | string |
   *
   * @maxItems 3
   */
  "Form Types": [] | [string] | [string, string] | [string, string, string];
}

export interface DkWebappKeywordSearchProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkWebappKeywordSearchNoResultProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkWebappQueryProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkWebappQueryNoResultProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkWebappSignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface DkWebappSortProperties {
  "Sort Type": string;
}

export interface DkWebappTableExpansionProperties {
  "Contains Latest Filing": boolean;
  Expanded: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Table Description": string;
}

export interface DkWebappTableSelectionProperties {
  "Contains Latest Filing": boolean;
  Expanded: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Table Description": string;
}

export interface DkWebappTextTableToggleProperties {
  /**
   * Source of KPI (e.g., Table or Text)
   */
  "KPI Source Type"?: string;
}

export interface DkWebappTimeSpanSelectionProperties {
  "Time Span": string;
}

export interface DkXlaCategorySelectionProperties {
  Expanded: boolean;
  "Section Name": string;
}

export interface DkXlaChartExpansionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface DkXlaChartSelectionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface DkXlaDataPullProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface DkXlaFormTypeChangeProperties {
  /**
   * A set of form types: 10-K, 10-Q, 8-K
   *
   * | Rule | Value |
   * |---|---|
   * | Max Items | 3 |
   * | Unique Items | true |
   * | Item Type | string |
   *
   * @maxItems 3
   */
  "Form Types": [] | [string] | [string, string] | [string, string, string];
}

export interface DkXlaKeywordSearchProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkXlaKeywordSearchNoResultProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkXlaQueryProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkXlaQueryNoResultProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface DkXlaSignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface DkXlaTableExpansionProperties {
  "Contains Latest Filing": boolean;
  Expanded: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Table Description": string;
}

export interface DkXlaTableSelectionProperties {
  "Contains Latest Filing": boolean;
  Expanded: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  "Table Description": string;
}

export interface DkXlaTextTableToggleProperties {
  /**
   * Source of KPI (e.g., Table or Text)
   */
  "KPI Source Type"?: string;
}

export interface KeywordSearchProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface LoginButtonClickProperties {
  "Button Location"?: string;
}

export interface MergeDataExportProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface NoKeywordSearchResultProperties {
  Keyword: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface NoQueryResultProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface QueryProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface SectionClickProperties {
  Expanded: boolean;
  "Section Name": string;
}

export interface SignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface SortProperties {
  "Sort Type": string;
}

export interface TabClickProperties {
  /**
   * Source of KPI (e.g., Table or Text)
   */
  "KPI Source Type"?: string;
}

export interface TimeSpanSelectionProperties {
  "Time Span": string;
}

export interface TimeSeriesChartViewExpansionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface TimeSeriesChartViewSelectionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Chart Index": number;
  "Chart Title": string;
  "Contains Latest Filing": boolean;
  Description: string;
  "Doc Type": string;
  Expanded: boolean;
  "Form Type": string;
  "Has Duplicate Time Series": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export interface TrackDownloadProperties {
  /**
   * Download URL
   */
  "Download URL": string;
}

export interface WwwWebappSignUpButtonClickProperties {
  "Button Location"?: string;
}

export interface AccountCreationFormDataProperties {
  Company: string;
  "Invitation Code": string;
}

export interface ExportRequestProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Export Details"?: string[];
  /**
   * Data API version
   */
  "Export Version"?: string;
}

export interface ProvenanceRequestProperties {
  /**
   * The caller requesting provenance data.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | app, docviewer |
   */
  "Provenance Caller": "app" | "docviewer";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Provenance Details": string[];
  /**
   * Data API version
   */
  "Provenance Version"?: string;
}

export interface QueryParametersProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Items | 2 |
   * | Max Items | 2 |
   * | Item Type | string |
   *
   * @minItems 2
   * @maxItems 2
   */
  "Query Date Range": [string, string];
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 3 |
   * | Max Length | 10 |
   */
  "Query Form Type": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   * | Max Length | 10 |
   */
  "Query Symbol"?: string;
}

export interface TimeSeriesProperties {
  "Chart Title": string;
  Description: string;
  "Doc Type": string;
  "Form Type": string;
  Hint: string;
  Modifier: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Score: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Section Idx": number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Series Length": number;
  Unit: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CommonCreateAccountCompleted implements BaseEvent {
  event_type = 'COMMON Create Account Completed';

  constructor(
    public event_properties: CommonCreateAccountCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CommonCreateAccountInitiated implements BaseEvent {
  event_type = 'COMMON Create Account Initiated';
}

export class CommonLoginCompleted implements BaseEvent {
  event_type = 'COMMON Login Completed';
}

export class CommonLoginInitiated implements BaseEvent {
  event_type = 'COMMON Login Initiated';
}

export class CommonWebappSignUpButtonClick implements BaseEvent {
  event_type = 'COMMON Webapp Sign Up Button Click';

  constructor(
    public event_properties?: CommonWebappSignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CreateAccountButtonClick implements BaseEvent {
  event_type = 'Create Account Button Click';

  constructor(
    public event_properties: CreateAccountButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DaWebappCitationChartView implements BaseEvent {
  event_type = 'DA Webapp Citation Chart View';
}

export class DaWebappCitationEarningsCallView implements BaseEvent {
  event_type = 'DA Webapp Citation Earnings Call View';
}

export class DaWebappCitationFilingView implements BaseEvent {
  event_type = 'DA Webapp Citation Filing View';
}

export class DaWebappCitationRationaleFocus implements BaseEvent {
  event_type = 'DA Webapp Citation Rationale Focus';
}

export class DaWebappCitationTableView implements BaseEvent {
  event_type = 'DA Webapp Citation Table View';
}

export class DaWebappQueryComplex implements BaseEvent {
  event_type = 'DA Webapp Query Complex';

  constructor(
    public event_properties: DaWebappQueryComplexProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DaWebappQuerySimple implements BaseEvent {
  event_type = 'DA Webapp Query Simple';

  constructor(
    public event_properties: DaWebappQuerySimpleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DaWebappSignUpButtonClick implements BaseEvent {
  event_type = 'DA Webapp Sign Up Button Click';

  constructor(
    public event_properties?: DaWebappSignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DataAudit implements BaseEvent {
  event_type = 'Data Audit';

  constructor(
    public event_properties: DataAuditProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DataExport implements BaseEvent {
  event_type = 'Data Export';

  constructor(
    public event_properties?: DataExportProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiDownloadedAsset implements BaseEvent {
  event_type = 'DI Downloaded Asset';

  constructor(
    public event_properties: DiDownloadedAssetProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkDataAudit implements BaseEvent {
  event_type = 'DK Data Audit';

  constructor(
    public event_properties: DkDataAuditProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappCategorySelection implements BaseEvent {
  event_type = 'DK Webapp Category Selection';

  constructor(
    public event_properties: DkWebappCategorySelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappChartExpansion implements BaseEvent {
  event_type = 'DK Webapp Chart Expansion';

  constructor(
    public event_properties: DkWebappChartExpansionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappChartSelection implements BaseEvent {
  event_type = 'DK Webapp Chart Selection';

  constructor(
    public event_properties: DkWebappChartSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappExcelExport implements BaseEvent {
  event_type = 'DK Webapp Excel Export';

  constructor(
    public event_properties?: DkWebappExcelExportProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappExcelExportMerge implements BaseEvent {
  event_type = 'DK Webapp Excel Export Merge';

  constructor(
    public event_properties?: DkWebappExcelExportMergeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappFormTypeChange implements BaseEvent {
  event_type = 'DK Webapp Form Type Change';

  constructor(
    public event_properties: DkWebappFormTypeChangeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappGetXla implements BaseEvent {
  event_type = 'DK Webapp Get XLA';
}

export class DkWebappKeywordSearch implements BaseEvent {
  event_type = 'DK Webapp Keyword Search';

  constructor(
    public event_properties: DkWebappKeywordSearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappKeywordSearchNoResult implements BaseEvent {
  event_type = 'DK Webapp Keyword Search No Result';

  constructor(
    public event_properties: DkWebappKeywordSearchNoResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappQuery implements BaseEvent {
  event_type = 'DK Webapp Query';

  constructor(
    public event_properties: DkWebappQueryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappQueryNoResult implements BaseEvent {
  event_type = 'DK Webapp Query No Result';

  constructor(
    public event_properties: DkWebappQueryNoResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappSignUpButtonClick implements BaseEvent {
  event_type = 'DK Webapp Sign Up Button Click';

  constructor(
    public event_properties?: DkWebappSignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappSort implements BaseEvent {
  event_type = 'DK Webapp Sort';

  constructor(
    public event_properties: DkWebappSortProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappTableExpansion implements BaseEvent {
  event_type = 'DK Webapp Table Expansion';

  constructor(
    public event_properties: DkWebappTableExpansionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappTableSelection implements BaseEvent {
  event_type = 'DK Webapp Table Selection';

  constructor(
    public event_properties: DkWebappTableSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappTextTableToggle implements BaseEvent {
  event_type = 'DK Webapp Text/Table Toggle';

  constructor(
    public event_properties?: DkWebappTextTableToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkWebappTimeSpanSelection implements BaseEvent {
  event_type = 'DK Webapp Time Span Selection';

  constructor(
    public event_properties: DkWebappTimeSpanSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaCategorySelection implements BaseEvent {
  event_type = 'DK XLA Category Selection';

  constructor(
    public event_properties: DkXlaCategorySelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaChartExpansion implements BaseEvent {
  event_type = 'DK XLA Chart Expansion';

  constructor(
    public event_properties: DkXlaChartExpansionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaChartSelection implements BaseEvent {
  event_type = 'DK XLA Chart Selection';

  constructor(
    public event_properties: DkXlaChartSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaDataPull implements BaseEvent {
  event_type = 'DK XLA Data Pull';

  constructor(
    public event_properties?: DkXlaDataPullProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaFormTypeChange implements BaseEvent {
  event_type = 'DK XLA Form Type Change';

  constructor(
    public event_properties: DkXlaFormTypeChangeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaKeywordSearch implements BaseEvent {
  event_type = 'DK XLA Keyword Search';

  constructor(
    public event_properties: DkXlaKeywordSearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaKeywordSearchNoResult implements BaseEvent {
  event_type = 'DK XLA Keyword Search No Result';

  constructor(
    public event_properties: DkXlaKeywordSearchNoResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaQuery implements BaseEvent {
  event_type = 'DK XLA Query';

  constructor(
    public event_properties: DkXlaQueryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaQueryNoResult implements BaseEvent {
  event_type = 'DK XLA Query No Result';

  constructor(
    public event_properties: DkXlaQueryNoResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaSignUpButtonClick implements BaseEvent {
  event_type = 'DK XLA Sign Up Button Click';

  constructor(
    public event_properties?: DkXlaSignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaTableExpansion implements BaseEvent {
  event_type = 'DK XLA Table Expansion';

  constructor(
    public event_properties: DkXlaTableExpansionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaTableSelection implements BaseEvent {
  event_type = 'DK XLA Table Selection';

  constructor(
    public event_properties: DkXlaTableSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DkXlaTextTableToggle implements BaseEvent {
  event_type = 'DK XLA Text/Table Toggle';

  constructor(
    public event_properties?: DkXlaTextTableToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class KeywordSearch implements BaseEvent {
  event_type = 'Keyword Search';

  constructor(
    public event_properties: KeywordSearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Login implements BaseEvent {
  event_type = 'Login';
}

export class LoginButtonClick implements BaseEvent {
  event_type = 'Login Button Click';

  constructor(
    public event_properties?: LoginButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MergeDataExport implements BaseEvent {
  event_type = 'Merge Data Export';

  constructor(
    public event_properties?: MergeDataExportProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NoKeywordSearchResult implements BaseEvent {
  event_type = 'No Keyword Search Result';

  constructor(
    public event_properties: NoKeywordSearchResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NoQueryResult implements BaseEvent {
  event_type = 'No Query Result';

  constructor(
    public event_properties: NoQueryResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Query implements BaseEvent {
  event_type = 'Query';

  constructor(
    public event_properties: QueryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SectionClick implements BaseEvent {
  event_type = 'Section Click';

  constructor(
    public event_properties: SectionClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SignUpButtonClick implements BaseEvent {
  event_type = 'Sign Up Button Click';

  constructor(
    public event_properties?: SignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Sort implements BaseEvent {
  event_type = 'Sort';

  constructor(
    public event_properties: SortProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TabClick implements BaseEvent {
  event_type = 'Tab Click';

  constructor(
    public event_properties?: TabClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TimeSpanSelection implements BaseEvent {
  event_type = 'Time Span Selection';

  constructor(
    public event_properties: TimeSpanSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TimeSeriesChartViewExpansion implements BaseEvent {
  event_type = 'TimeSeries Chart View Expansion';

  constructor(
    public event_properties: TimeSeriesChartViewExpansionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TimeSeriesChartViewSelection implements BaseEvent {
  event_type = 'TimeSeries Chart View Selection';

  constructor(
    public event_properties: TimeSeriesChartViewSelectionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TrackDownload implements BaseEvent {
  event_type = 'Track Download';

  constructor(
    public event_properties: TrackDownloadProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WwwWebappSignUpButtonClick implements BaseEvent {
  event_type = 'WWW Webapp Sign Up Button Click';

  constructor(
    public event_properties?: WwwWebappSignUpButtonClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * COMMON Create Account Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/COMMON%20Create%20Account%20Completed)
   *
   * When a user clicks on the "Create Account" button to submit the sign up form.
   *
   * @param properties The event's properties (e.g. Company)
   * @param options Amplitude event options.
   */
  commonCreateAccountCompleted(
    properties: CommonCreateAccountCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommonCreateAccountCompleted(properties), options);
  }

  /**
   * COMMON Create Account Initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/COMMON%20Create%20Account%20Initiated)
   *
   * When a user clicks on the "Create Account" button to submit the sign up form.
   *
   * @param options Amplitude event options.
   */
  commonCreateAccountInitiated(
    options?: EventOptions,
  ) {
    return this.track(new CommonCreateAccountInitiated(), options);
  }

  /**
   * COMMON Login Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/COMMON%20Login%20Completed)
   *
   * This event tracks when a user successfully logs into the platform
   *
   * @param options Amplitude event options.
   */
  commonLoginCompleted(
    options?: EventOptions,
  ) {
    return this.track(new CommonLoginCompleted(), options);
  }

  /**
   * COMMON Login Initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/COMMON%20Login%20Initiated)
   *
   * Event that captures when a user clicks on the login button
   *
   * @param options Amplitude event options.
   */
  commonLoginInitiated(
    options?: EventOptions,
  ) {
    return this.track(new CommonLoginInitiated(), options);
  }

  /**
   * COMMON Webapp Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/COMMON%20Webapp%20Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on a "Sign Up" button
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  commonWebappSignUpButtonClick(
    properties?: CommonWebappSignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommonWebappSignUpButtonClick(properties), options);
  }

  /**
   * Create Account Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Create%20Account%20Button%20Click)
   *
   * Event triggered when a user clicks on the "Create Account" button
   *
   * @param properties The event's properties (e.g. Company)
   * @param options Amplitude event options.
   */
  createAccountButtonClick(
    properties: CreateAccountButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateAccountButtonClick(properties), options);
  }

  /**
   * DA Webapp Citation Chart View
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Citation%20Chart%20View)
   *
   * Event to track when a user views a citation chart within the deepAnalysis web app.
   *
   * @param options Amplitude event options.
   */
  daWebappCitationChartView(
    options?: EventOptions,
  ) {
    return this.track(new DaWebappCitationChartView(), options);
  }

  /**
   * DA Webapp Citation Earnings Call View
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Citation%20Earnings%20Call%20View)
   *
   * Event to track when a user views an earnings call citation within the deepAnalysis web app.
   *
   * @param options Amplitude event options.
   */
  daWebappCitationEarningsCallView(
    options?: EventOptions,
  ) {
    return this.track(new DaWebappCitationEarningsCallView(), options);
  }

  /**
   * DA Webapp Citation Filing View
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Citation%20Filing%20View)
   *
   * Event to track when a user views a citation document within the deepAnalysis web app.
   *
   * @param options Amplitude event options.
   */
  daWebappCitationFilingView(
    options?: EventOptions,
  ) {
    return this.track(new DaWebappCitationFilingView(), options);
  }

  /**
   * DA Webapp Citation Rationale Focus
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Citation%20Rationale%20Focus)
   *
   * Event to track when a user focuses on the deepAnalysis rationale box
   *
   * @param options Amplitude event options.
   */
  daWebappCitationRationaleFocus(
    options?: EventOptions,
  ) {
    return this.track(new DaWebappCitationRationaleFocus(), options);
  }

  /**
   * DA Webapp Citation Table View
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Citation%20Table%20View)
   *
   * Event to track when a user views a table citation within the deepAnalysis web app.
   *
   * @param options Amplitude event options.
   */
  daWebappCitationTableView(
    options?: EventOptions,
  ) {
    return this.track(new DaWebappCitationTableView(), options);
  }

  /**
   * DA Webapp Query Complex
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Query%20Complex)
   *
   * This event tracks when a user performs a Report Writer query within the deepAnalysis webapp
   *
   * @param properties The event's properties (e.g. Chat Query)
   * @param options Amplitude event options.
   */
  daWebappQueryComplex(
    properties: DaWebappQueryComplexProperties,
    options?: EventOptions,
  ) {
    return this.track(new DaWebappQueryComplex(properties), options);
  }

  /**
   * DA Webapp Query Simple
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Query%20Simple)
   *
   * This event tracks when a user performs a Q&A query within the deepAnalysis webapp
   *
   * @param properties The event's properties (e.g. Chat Query)
   * @param options Amplitude event options.
   */
  daWebappQuerySimple(
    properties: DaWebappQuerySimpleProperties,
    options?: EventOptions,
  ) {
    return this.track(new DaWebappQuerySimple(properties), options);
  }

  /**
   * DA Webapp Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DA%20Webapp%20Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on a "Sign Up" button on deepAnalysis webapp
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  daWebappSignUpButtonClick(
    properties?: DaWebappSignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new DaWebappSignUpButtonClick(properties), options);
  }

  /**
   * Data Audit
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Data%20Audit)
   *
   * This even tracks when and what data provenance is requested
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dataAudit(
    properties: DataAuditProperties,
    options?: EventOptions,
  ) {
    return this.track(new DataAudit(properties), options);
  }

  /**
   * Data Export
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Data%20Export)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. Export Details)
   * @param options Amplitude event options.
   */
  dataExport(
    properties?: DataExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new DataExport(properties), options);
  }

  /**
   * DI Downloaded Asset
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DI%20Downloaded%20Asset)
   *
   * This event captures when a user initiates a download action within the deepInsight application.
   *
   * @param properties The event's properties (e.g. Download URL)
   * @param options Amplitude event options.
   */
  diDownloadedAsset(
    properties: DiDownloadedAssetProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiDownloadedAsset(properties), options);
  }

  /**
   * DK Data Audit
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Data%20Audit)
   *
   * This even tracks when and what data provenance is requested
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dkDataAudit(
    properties: DkDataAuditProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkDataAudit(properties), options);
  }

  /**
   * DK Webapp Category Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Category%20Selection)
   *
   * This event tracks when a user selects a KPI category (was: section) in the deepKPI webapp
   *
   * @param properties The event's properties (e.g. Expanded)
   * @param options Amplitude event options.
   */
  dkWebappCategorySelection(
    properties: DkWebappCategorySelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappCategorySelection(properties), options);
  }

  /**
   * DK Webapp Chart Expansion
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Chart%20Expansion)
   *
   * Event tracking when a user expands a TimeSeries chart view in deepKPI webapp
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dkWebappChartExpansion(
    properties: DkWebappChartExpansionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappChartExpansion(properties), options);
  }

  /**
   * DK Webapp Chart Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Chart%20Selection)
   *
   * Event tracking when a user selects a time series chart for export in the deepKPI webapp
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dkWebappChartSelection(
    properties: DkWebappChartSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappChartSelection(properties), options);
  }

  /**
   * DK Webapp Excel Export
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Excel%20Export)
   *
   * Event to track when users export data to Excel within the DeepKPI web app.
   *
   * @param properties The event's properties (e.g. Export Details)
   * @param options Amplitude event options.
   */
  dkWebappExcelExport(
    properties?: DkWebappExcelExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappExcelExport(properties), options);
  }

  /**
   * DK Webapp Excel Export Merge
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Excel%20Export%20Merge)
   *
   * Event to track when merge export occurs on the deepKPI webapp
   *
   * @param properties The event's properties (e.g. Export Details)
   * @param options Amplitude event options.
   */
  dkWebappExcelExportMerge(
    properties?: DkWebappExcelExportMergeProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappExcelExportMerge(properties), options);
  }

  /**
   * DK Webapp Form Type Change
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Form%20Type%20Change)
   *
   * This event tracks when a user changes the type of SEC form they are interacting with on the deepKPI webapp.
   *
   * @param properties The event's properties (e.g. Form Types)
   * @param options Amplitude event options.
   */
  dkWebappFormTypeChange(
    properties: DkWebappFormTypeChangeProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappFormTypeChange(properties), options);
  }

  /**
   * DK Webapp Get XLA
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Get%20XLA)
   *
   * Event to track when users click the "Get Excel Add-in" button in the deepKPI webapp
   *
   * @param options Amplitude event options.
   */
  dkWebappGetXla(
    options?: EventOptions,
  ) {
    return this.track(new DkWebappGetXla(), options);
  }

  /**
   * DK Webapp Keyword Search
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Keyword%20Search)
   *
   * Event triggered when a user performs a keyword search within the deepKPI webapp Datapane
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  dkWebappKeywordSearch(
    properties: DkWebappKeywordSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappKeywordSearch(properties), options);
  }

  /**
   * DK Webapp Keyword Search No Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Keyword%20Search%20No%20Result)
   *
   * This event tracks when a user performs a search with no relevant results found on the deepKPI webapp
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  dkWebappKeywordSearchNoResult(
    properties: DkWebappKeywordSearchNoResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappKeywordSearchNoResult(properties), options);
  }

  /**
   * DK Webapp Query
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Query)
   *
   * This event tracks when a user performs a search query within the deepKPI webapp
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  dkWebappQuery(
    properties: DkWebappQueryProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappQuery(properties), options);
  }

  /**
   * DK Webapp Query No Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Query%20No%20Result)
   *
   * This event tracks when a user performs a search query within the deepKPI webapp and a user's search query returns no results.
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  dkWebappQueryNoResult(
    properties: DkWebappQueryNoResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappQueryNoResult(properties), options);
  }

  /**
   * DK Webapp Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on a "Sign Up" button on deepKPI webapp
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  dkWebappSignUpButtonClick(
    properties?: DkWebappSignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappSignUpButtonClick(properties), options);
  }

  /**
   * DK Webapp Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Sort)
   *
   * This event tracks when a user sorts timeseries on data pane.
   *
   * @param properties The event's properties (e.g. Sort Type)
   * @param options Amplitude event options.
   */
  dkWebappSort(
    properties: DkWebappSortProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappSort(properties), options);
  }

  /**
   * DK Webapp Table Expansion
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Table%20Expansion)
   *
   * Event tracking when a user expands a TimeSeries chart view in deepKPI webapp
   *
   * @param properties The event's properties (e.g. Contains Latest Filing)
   * @param options Amplitude event options.
   */
  dkWebappTableExpansion(
    properties: DkWebappTableExpansionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappTableExpansion(properties), options);
  }

  /**
   * DK Webapp Table Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Table%20Selection)
   *
   * Event tracking when a user clicks the checkbox on a TimeSeries chart view in deepKPI webapp
   *
   * @param properties The event's properties (e.g. Contains Latest Filing)
   * @param options Amplitude event options.
   */
  dkWebappTableSelection(
    properties: DkWebappTableSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappTableSelection(properties), options);
  }

  /**
   * DK Webapp Text/Table Toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Text%2FTable%20Toggle)
   *
   * Event that captures when a user clicks on a Text or Table tab within the application.
   *
   * @param properties The event's properties (e.g. KPI Source Type)
   * @param options Amplitude event options.
   */
  dkWebappTextTableToggle(
    properties?: DkWebappTextTableToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappTextTableToggle(properties), options);
  }

  /**
   * DK Webapp Time Span Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20Webapp%20Time%20Span%20Selection)
   *
   * Event to track when users select a time span in deepKPI webapp
   *
   * @param properties The event's properties (e.g. Time Span)
   * @param options Amplitude event options.
   */
  dkWebappTimeSpanSelection(
    properties: DkWebappTimeSpanSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkWebappTimeSpanSelection(properties), options);
  }

  /**
   * DK XLA Category Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Category%20Selection)
   *
   * This event tracks when a user selects a KPI category (was: section) in the deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Expanded)
   * @param options Amplitude event options.
   */
  dkXlaCategorySelection(
    properties: DkXlaCategorySelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaCategorySelection(properties), options);
  }

  /**
   * DK XLA Chart Expansion
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Chart%20Expansion)
   *
   * Event tracking when a user expands a TimeSeries chart view in deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dkXlaChartExpansion(
    properties: DkXlaChartExpansionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaChartExpansion(properties), options);
  }

  /**
   * DK XLA Chart Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Chart%20Selection)
   *
   * Event tracking when a user selects a time series chart for export in the deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  dkXlaChartSelection(
    properties: DkXlaChartSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaChartSelection(properties), options);
  }

  /**
   * DK XLA Data Pull
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Data%20Pull)
   *
   * Event to track when users pull data into Excel via the Excel add-in.
   *
   * @param properties The event's properties (e.g. Export Details)
   * @param options Amplitude event options.
   */
  dkXlaDataPull(
    properties?: DkXlaDataPullProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaDataPull(properties), options);
  }

  /**
   * DK XLA Form Type Change
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Form%20Type%20Change)
   *
   * This event tracks when a user changes the type of SEC form they are interacting with on the deepKPI Excel add-in.
   *
   * @param properties The event's properties (e.g. Form Types)
   * @param options Amplitude event options.
   */
  dkXlaFormTypeChange(
    properties: DkXlaFormTypeChangeProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaFormTypeChange(properties), options);
  }

  /**
   * DK XLA Keyword Search
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Keyword%20Search)
   *
   * Event triggered when a user performs a keyword search within the deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  dkXlaKeywordSearch(
    properties: DkXlaKeywordSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaKeywordSearch(properties), options);
  }

  /**
   * DK XLA Keyword Search No Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Keyword%20Search%20No%20Result)
   *
   * This event tracks when a user performs a search with no relevant results found on the deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  dkXlaKeywordSearchNoResult(
    properties: DkXlaKeywordSearchNoResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaKeywordSearchNoResult(properties), options);
  }

  /**
   * DK XLA Query
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Query)
   *
   * This event tracks when a user performs a search query within the deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  dkXlaQuery(
    properties: DkXlaQueryProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaQuery(properties), options);
  }

  /**
   * DK XLA Query No Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Query%20No%20Result)
   *
   * This event tracks when a user performs a search query within the deepKPI Excel add-in and a user's search query returns no results.
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  dkXlaQueryNoResult(
    properties: DkXlaQueryNoResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaQueryNoResult(properties), options);
  }

  /**
   * DK XLA Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on a "Sign Up" button on deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  dkXlaSignUpButtonClick(
    properties?: DkXlaSignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaSignUpButtonClick(properties), options);
  }

  /**
   * DK XLA Table Expansion
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Table%20Expansion)
   *
   * Event tracking when a user expands a TimeSeries chart view in deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Contains Latest Filing)
   * @param options Amplitude event options.
   */
  dkXlaTableExpansion(
    properties: DkXlaTableExpansionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaTableExpansion(properties), options);
  }

  /**
   * DK XLA Table Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Table%20Selection)
   *
   * Event tracking when a user expands a TimeSeries chart view in deepKPI Excel add-in
   *
   * @param properties The event's properties (e.g. Contains Latest Filing)
   * @param options Amplitude event options.
   */
  dkXlaTableSelection(
    properties: DkXlaTableSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaTableSelection(properties), options);
  }

  /**
   * DK XLA Text/Table Toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/DK%20XLA%20Text%2FTable%20Toggle)
   *
   * Event that captures when a user clicks on a Text or Table tab within the Excel add-in.
   *
   * @param properties The event's properties (e.g. KPI Source Type)
   * @param options Amplitude event options.
   */
  dkXlaTextTableToggle(
    properties?: DkXlaTextTableToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new DkXlaTextTableToggle(properties), options);
  }

  /**
   * Keyword Search
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Keyword%20Search)
   *
   * Event triggered when a user performs a keyword search within the Datapane
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  keywordSearch(
    properties: KeywordSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new KeywordSearch(properties), options);
  }

  /**
   * Login
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Login)
   *
   * This event tracks when a user successfully logs into the platform
   *
   * @param options Amplitude event options.
   */
  login(
    options?: EventOptions,
  ) {
    return this.track(new Login(), options);
  }

  /**
   * Login Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Login%20Button%20Click)
   *
   * Event that captures when a user clicks on the login button
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  loginButtonClick(
    properties?: LoginButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new LoginButtonClick(properties), options);
  }

  /**
   * Merge Data Export
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Merge%20Data%20Export)
   *
   * Event to track when data is exported using merge selection
   *
   * @param properties The event's properties (e.g. Export Details)
   * @param options Amplitude event options.
   */
  mergeDataExport(
    properties?: MergeDataExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new MergeDataExport(properties), options);
  }

  /**
   * No Keyword Search Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/No%20Keyword%20Search%20Result)
   *
   * This event tracks when a user performs a search with no relevant results found
   *
   * @param properties The event's properties (e.g. Keyword)
   * @param options Amplitude event options.
   */
  noKeywordSearchResult(
    properties: NoKeywordSearchResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new NoKeywordSearchResult(properties), options);
  }

  /**
   * No Query Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/No%20Query%20Result)
   *
   * This event tracks when a user performs a search query within the application and a user's search query returns no results.
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  noQueryResult(
    properties: NoQueryResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new NoQueryResult(properties), options);
  }

  /**
   * Query
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Query)
   *
   * This event tracks when a user performs a search query within the application
   *
   * @param properties The event's properties (e.g. Query Date Range)
   * @param options Amplitude event options.
   */
  query(
    properties: QueryProperties,
    options?: EventOptions,
  ) {
    return this.track(new Query(properties), options);
  }

  /**
   * Section Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Section%20Click)
   *
   * This event tracks when a user clicks on a section of a document within Datapane (e.g., Part I, Part II and etc)
   *
   * @param properties The event's properties (e.g. Expanded)
   * @param options Amplitude event options.
   */
  sectionClick(
    properties: SectionClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SectionClick(properties), options);
  }

  /**
   * Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on the sign-up button
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  signUpButtonClick(
    properties?: SignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignUpButtonClick(properties), options);
  }

  /**
   * Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Sort)
   *
   * This event tracks when a user sorts timeseries on data pane.
   *
   * @param properties The event's properties (e.g. Sort Type)
   * @param options Amplitude event options.
   */
  sort(
    properties: SortProperties,
    options?: EventOptions,
  ) {
    return this.track(new Sort(properties), options);
  }

  /**
   * Tab Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Tab%20Click)
   *
   * Event that captures when a user clicks on a Text or Table tab within the application.
   *
   * @param properties The event's properties (e.g. KPI Source Type)
   * @param options Amplitude event options.
   */
  tabClick(
    properties?: TabClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new TabClick(properties), options);
  }

  /**
   * Time Span Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Time%20Span%20Selection)
   *
   * Event to track when users select a time span
   *
   * @param properties The event's properties (e.g. Time Span)
   * @param options Amplitude event options.
   */
  timeSpanSelection(
    properties: TimeSpanSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new TimeSpanSelection(properties), options);
  }

  /**
   * TimeSeries Chart View Expansion
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/TimeSeries%20Chart%20View%20Expansion)
   *
   * Event tracking when a user expands a TimeSeries chart view
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  timeSeriesChartViewExpansion(
    properties: TimeSeriesChartViewExpansionProperties,
    options?: EventOptions,
  ) {
    return this.track(new TimeSeriesChartViewExpansion(properties), options);
  }

  /**
   * TimeSeries Chart View Selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/TimeSeries%20Chart%20View%20Selection)
   *
   * Event tracking when a user selects a time series chart view
   *
   * @param properties The event's properties (e.g. Chart Index)
   * @param options Amplitude event options.
   */
  timeSeriesChartViewSelection(
    properties: TimeSeriesChartViewSelectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new TimeSeriesChartViewSelection(properties), options);
  }

  /**
   * Track Download
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/Track%20Download)
   *
   * This event captures when a user initiates a download action within the deepInsight application.
   *
   * @param properties The event's properties (e.g. Download URL)
   * @param options Amplitude event options.
   */
  trackDownload(
    properties: TrackDownloadProperties,
    options?: EventOptions,
  ) {
    return this.track(new TrackDownload(properties), options);
  }

  /**
   * WWW Webapp Sign Up Button Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/revelata/deepkpi_test/events/main/latest/WWW%20Webapp%20Sign%20Up%20Button%20Click)
   *
   * Event that captures when a user clicks on a "Sign Up" button on deepAnalysis webapp
   *
   * @param properties The event's properties (e.g. Button Location)
   * @param options Amplitude event options.
   */
  wwwWebappSignUpButtonClick(
    properties?: WwwWebappSignUpButtonClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new WwwWebappSignUpButtonClick(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
